import React from "react";
import { Lightbox, LightboxType } from "../../../../../../../react-core/Html/Components/Lightbox";
import { FormComponent } from "../../../../../../../react-core/Html/FormComponent";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";
import { BwaBranchDataReferral } from "../../../../../../../Wrap/Models/Domains/BankAccount/BwaBranchDataReferral";

interface IBankAccountSuccessPopupViewProps {
    showBox: boolean;
    onClose: () => void;
    onCancelClick: () => void;
    onContinueClick: () => void;
    data: BwaBranchDataReferral;
}

export class BankAccountSuccessPopupView extends FormComponent<IBankAccountSuccessPopupViewProps, {}> {
    constructor(props: IBankAccountSuccessPopupViewProps) {
        super(props);
    }

    public render(): JSX.Element {
        return <>{this.props.showBox ? this.renderModal() : null}</>;
    }

    private renderModal(): JSX.Element {
        return (
            <Lightbox
                show={this.props.showBox}
                title={"Bank branch"}
                contentAfterTitle={null}
                onClose={() => this.props.onClose()}
                type={LightboxType.Modal}
                unclosable={false}
                noOverlay={false}
                noAutofocus={false}
                cssWrapper={"is-default-lightbox"}
            >
                {this.getModalBody()}
            </Lightbox>
        );
    }

    private getModalBody(): JSX.Element {
        const { data } = this.props;
        return (
            <>
                <TextBoxEditor label="Bank name" disabled={false} value={data?.InstitutionName} onChange={() => {}} />
                <TextBoxEditor
                    label="Address Line 1"
                    disabled={false}
                    value={data?.AddressLines[0]}
                    onChange={() => {}}
                />
                <TextBoxEditor
                    label="Address Line 2"
                    disabled={false}
                    value={data?.AddressLines[1]}
                    onChange={() => {}}
                />
                <TextBoxEditor
                    label="Address Line 3"
                    disabled={false}
                    value={data?.AddressLines[2]}
                    onChange={() => {}}
                />
                <TextBoxEditor label="Post Code" disabled={false} value={data?.PostOrZipCode} onChange={() => {}} />
                <button className="btn secondary mr-10" onClick={() => this.props.onCancelClick()}>
                    Cancel
                </button>
                <button className="btn primary" onClick={() => this.props.onContinueClick()}>
                    Continue
                </button>
            </>
        );
    }
}
